import { FileText, Plus } from 'lucide-react'

import { Button } from '@/components/ui/button'

interface DocumentsEmptyStateProps {
  onCreate: () => void
  isCreating?: boolean
}

export function DocumentsEmptyState({ onCreate, isCreating }: DocumentsEmptyStateProps) {
  return (
    <div className="flex flex-col items-center gap-4 py-16 text-center">
      <div className="flex size-12 items-center justify-center rounded-full bg-muted">
        <FileText className="size-6 text-muted-foreground" />
      </div>
      <div className="flex flex-col gap-1">
        <p className="text-sm font-medium text-foreground">No documents yet</p>
        <p className="max-w-sm text-sm text-muted-foreground">
          Create a blank page for notes, specs, or anything your team needs to share.
        </p>
      </div>
      <Button onClick={onCreate} disabled={isCreating}>
        <Plus data-icon="inline-start" />
        New document
      </Button>
    </div>
  )
}
